import Vue from 'vue'
import conf from '@/assets/script/conf'

//全局公共变量

export default function () {
  Vue.prototype.$global = Object.assign(conf,{

  })
}


// WEBPACK FOOTER //
// ./src/assets/script/global.js